import React, { useEffect, useContext, useState } from 'react';
import { arrayOf, bool, shape } from 'prop-types';
import { ReservationContext } from '../../context/reservation-context';
import { NO_AVAILABILITY, CLOSEST_AVAILABILITY, EXACT_AVAILABILITY } from '../../constants/messages';
import helper from '../../utils/helper';

import './availability-status-message.scss';

const MESSAGE_TYPE_EXACT_MATCH = 'Exact';
const MESSAGE_TYPE_CLOSEST_MATCH = 'Closest';
const MESSAGE_TYPE_UNAVAILABLE = 'Unavailable';

const ExactMessage = () => <div className="exact-message">{EXACT_AVAILABILITY}</div>;
const ClosestMessage = () => <div className="closest-message">{CLOSEST_AVAILABILITY}</div>;
const NoAvailabilityMessage = () => <div className="no-availability-message">{NO_AVAILABILITY}</div>;

export const AvailabilityStatusMessage = ({ availabilityData, isLoading }) => {

  const [messageType, setMessageType] = useState();
  const [{ reservation }] = useContext(ReservationContext);

  useEffect(() => {

    if (
      availabilityData.length === 0
      || availabilityData.every((availability) => !availability.availableHours?.length > 0)
    ) {
      setMessageType(MESSAGE_TYPE_UNAVAILABLE);
    } else if (helper.checkExactAvailability({ store: availabilityData[0], reservation })) {
      setMessageType(MESSAGE_TYPE_EXACT_MATCH);
    } else {
      setMessageType(MESSAGE_TYPE_CLOSEST_MATCH);
    }

  }, [availabilityData]);

  if (!isLoading && messageType === MESSAGE_TYPE_CLOSEST_MATCH) {
    return <ClosestMessage />;
  }

  if (!isLoading && messageType === MESSAGE_TYPE_EXACT_MATCH) {
    return <ExactMessage />;
  }

  if (!isLoading && messageType === MESSAGE_TYPE_UNAVAILABLE) {
    return <NoAvailabilityMessage />;
  }

  return null;

};

AvailabilityStatusMessage.propTypes = {
  availabilityData: arrayOf(shape({})).isRequired,
  isLoading: bool.isRequired,
};
